import "./HeroSplineLoadingOverlay.css";

export const HERO_LOADING_LABEL = "DSITESOLUTION LOADING....";

export default function HeroSplineLoadingOverlay({ visible = true }) {
  if (!visible) return null;

  return (
    <div
      className="ds-hero-spline-loading"
      data-testid="hero-spline-loading"
      aria-live="polite"
      aria-busy="true"
    >
      <span className="ds-hero-spline-loading__text">{HERO_LOADING_LABEL}</span>
    </div>
  );
}
